module.exports = __webpack_public_path__ + "img/car_2_mitsubishi.1c989574.jpg";